import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress the harmless "ResizeObserver loop completed with undelivered notifications"
// warning emitted by Radix UI / Recharts which CRA's react-error-overlay otherwise
// promotes to a full-screen uncaught error in dev/preview builds.
const RESIZE_OBSERVER_LOOP_ERR_RE =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e?.message && RESIZE_OBSERVER_LOOP_ERR_RE.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || "";
    if (RESIZE_OBSERVER_LOOP_ERR_RE.test(msg)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
